import { createFetchAction } from '../helpers/fetch';
import { getToken, filteredLogout, buildInternalApiUrl } from '../../helpers';
import { WARNING_TOASTER } from '../toaster/toaster';

// Actions
export const GET_USER_ROLES = 'GET_USER_ROLES';

// Action Creators
export function getUserRoles() {
  const token = getToken();
  const url = `${buildInternalApiUrl(token)}/roles`;
  const logoutFilter = /^.*\/onboarding.aspx(?:\?[^?]*$)?$/i;
  return createFetchAction(GET_USER_ROLES, {
    url,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },

  }, 'GETTING_USER_ROLES', {
    fallbackAction: () => { filteredLogout(logoutFilter); },
    errorCodes: [401],
    failureMessage: { type: WARNING_TOASTER, exclusions: [logoutFilter] },
  });
}

// Initial State
const INITIAL_STATE = {
  roles: [],
};

// Reducers
export function user(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_USER_ROLES: {
      const { payload: { roles } } = action;
      return {
        ...state,
        roles,
      };
    }
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/user/user.js